import RecurlyPaymentForm from './RecurlyPaymentForm';

export default RecurlyPaymentForm;
